import { render } from "./SerialList.vue?vue&type=template&id=b6b51ffa"
import script from "./SerialList.vue?vue&type=script&lang=ts"
export * from "./SerialList.vue?vue&type=script&lang=ts"
script.render = render

export default script